import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpotOnGameCoreService } from './spot-on-game-core.service';
import { SpotOnGameSelectorComponent } from './spot-on-game-selector/spot-on-game-selector.component';

@NgModule({
  declarations: [SpotOnGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [SpotOnGameCoreService],
  exports: [SpotOnGameSelectorComponent],
})
export class SpotOnGameCoreModule {}
